import { useSplashBlocker } from '@app/core/splash/useSplashBlocker';
import { PropsWithChildren } from 'react';

/**
 * Returns true when `preview_splash` is present and not an explicit off value
 * (`0` / `false`). Supports `?preview_splash`, `?preview_splash=1`, and `=true`.
 */
function isPreviewSplashEnabled(): boolean {
  const value = new URLSearchParams(window.location.search).get('preview_splash');
  if (value === null) {
    return false;
  }
  return value !== '0' && value.toLowerCase() !== 'false';
}

/**
 * Forces the branded splash when `?preview_splash` is set, so style can be reviewed
 * without waiting for a real bootstrap load. Uses the shared SplashOverlay.
 */
export function SplashPreviewGate({ children }: PropsWithChildren<object>) {
  const preview = isPreviewSplashEnabled();
  useSplashBlocker('preview', preview);

  if (preview) {
    return null;
  }

  return <>{children}</>;
}
